module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Reflection.app","short_name":"Reflection.app","start_url":"/","background_color":"#ffffff","theme_color":"#ffffff","display":"minimal-ui","icon":"src/images/apple-touch-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"1e5edc1a1307f36c2de11658ec0764c4"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-142473134-1","head":false,"anonymize":true,"respectDNT":true,"exclude":["/preview/**"],"optimizeId":"","experimentId":"","variationId":"","sampleRate":5,"siteSpeedSampleRate":10,"cookieDomain":"my.reflection.app"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
